import { SECTION_PATHS } from '../constants/site';
import { scrollToSection } from '../utils/scrollToSection';


// Riktig länk (permalänk, öppna i ny flik, sökmotorer) som smooth-scrollar när man klickar
const NavLink = ({ target, className = "", children }) => {

    const handleClick = (event) => {
        // Låt webbläsaren sköta ctrl/cmd-klick och liknande
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        scrollToSection(target, { smooth: true });
    };

    return (
        <a
            href={SECTION_PATHS[target] ?? "/"}
            onClick={handleClick}
            className={`cursor-pointer ${className}`}
        >
            {children}
        </a>
    )
}


export default NavLink;
